interface State {
  layout: any,
  botPlacement: any,
  widgetID: any,
  widgetHeightOverride: number | null,
  homeRoute: any,
  prefill: any,
  notice: any,
  showCookieConsent: boolean | null,
  menu: any,
  maintenance: any
}

export const useLayoutStore = defineStore('layout', {
  state: () => {
    return {
      layout: null,
      botPlacement: null,
      widgetID: null,
      widgetHeightOverride: null,
      homeRoute: null,
      prefill: null,
      notice: null,
      showCookieConsent: null,
      menu: false,
      maintenance: null
    } as State
  },
  actions:{
    setLayout (layout: any) {
      this.layout = layout
    },
    setWidgetID (widgetID: any) {
      this.widgetID = widgetID
    },
    setWidgetHeightOverride (height: number | null) {
      this.widgetHeightOverride = height
    },
    setBotPlacement (placement: any) {
      this.botPlacement = placement
    },
    setHomeRoute (homeRoute: any) {
      this.homeRoute = homeRoute
    },
    setPrefill (prefill: any) {
      this.prefill = prefill
    },
    setNotice (notice: any) {
      this.notice = notice
    },
    setShowCookieConsent (showCookieConsent: boolean | null) {
      this.showCookieConsent = showCookieConsent
    },
    setMenu (menu: any) {
      this.menu = menu
    },
    setMaintenance(maintenance: any) {
      this.maintenance = maintenance
    }
  }
})
